import { lightenColor as s, HEX_COLORS as c, TransparencyEnum as e } from "@partoohub/branding";
const r = s(c.success, e.LIGHT);
export {
  r as successLightFixed
};
